import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: 'md'
    },

    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#08979C',
                secondary: '#404A5B',
                accent: '#FAAD14',
                accentLight: '#FFF1B8',
                activeStatus: '#00C058',
                inactiveStatus: '#C7C7C7',
                error: '#F44336',
                body: '#E5E5E5'
            },

            dark: {
                primary: '#08979C',
                secondary: '#404A5B',
                accent: '#FAAD14',
                accentLight: '#FFF1B8',
                activeStatus: '#00C058',
                inactiveStatus: '#C7C7C7',
                error: '#F44336',
                body: '#E5E5E5'
            }
        }
    }
})
